import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import NavigationEntity from '../../../types/NavigationEntity';

const NavigationEntityTextItem = ({
  className,
  entity,
  icon,
  isNoFollowLink,
  ...rest
}) => {
  const { active, label } = entity;

  if (!entity) {
    return null;
  }

  // nav-item class is used for now to match Bootstrap class names.
  // Should be changed in the future.
  return (
    <span
      className={classNames('NavigationEntityTextItem', 'nav-text', className, {
        active,
      })}
      {...rest}
    >
      {label}
      {icon}
    </span>
  );
};

NavigationEntityTextItem.propTypes = {
  entity: NavigationEntity.isRequired,
  className: PropTypes.string,
  icon: PropTypes.node,
  isNoFollowLink: PropTypes.bool,
};

export default NavigationEntityTextItem;
